import { Navigate, useSearchParams } from "react-router-dom";
import { Routes } from "../../../routes";

export default function UserMyReferrals() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "direct";
  const focus = searchParams.get("focus");
  const query = focus ? `?tab=${tab}&focus=${focus}` : `?tab=${tab}`;

  return (
    <Navigate
      to={`${Routes?.UserLevelNetworkPage?.path || "/user-level-network-page"}${query}`}
      replace
    />
  );
}
